import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import HeaderFour from '../Components/Header/HeaderFour';
import FooterThree from '../Components/Footer/FooterThree';
import ScrollToTop from '../Components/ScrollToTop';
import { useTourismActions } from '../context/TourismContext';

function Accommodation() {
    const location = useLocation();
    const { fetchAccommodations } = useTourismActions();
    const [accommodations, setAccommodations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchParams, setSearchParams] = useState({});

    useEffect(() => {
        // Parse URL search parameters
        const urlParams = new URLSearchParams(location.search);
        const params = {
            location: urlParams.get('location') || '',
            type: urlParams.get('type') || '',
            checkin: urlParams.get('checkin') || '',
            checkout: urlParams.get('checkout') || '',
            guests: parseInt(urlParams.get('guests')) || 2,
            adults: parseInt(urlParams.get('adults')) || 1,
            children: parseInt(urlParams.get('children')) || 0
        };
        setSearchParams(params);
    }, [location.search]);

    useEffect(() => {
        const loadAccommodations = async () => {
            try {
                setLoading(true);
                const data = await fetchAccommodations();
                setAccommodations(data || []);
            } catch (error) {
                console.error('Error loading accommodations:', error);
                setAccommodations([]);
            } finally {
                setLoading(false);
            }
        };

        loadAccommodations();
    }, [fetchAccommodations]);

    return (
        <div>
            <HeaderFour />
            
            {/* Page Header */}
            <div className="breadcumb-wrapper" style={{
                backgroundImage: "url(/assets/img/bg/breadcumb-bg.jpg)"
            }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">Accommodations</h1>
                        <ul className="breadcumb-menu">
                            <li><a href="/">Home</a></li>
                            <li>Accommodations</li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Search Info */}
            {(searchParams.location || searchParams.checkin) && (
                <div className="container my-4">
                    <div className="alert alert-info">
                        <h5>Search Results</h5>
                        <p>
                            {searchParams.location && `Location: ${searchParams.location} `}
                            {searchParams.checkin && `• Check-in: ${searchParams.checkin} `}
                            {searchParams.checkout && `• Check-out: ${searchParams.checkout} `}
                            {searchParams.guests && `• Guests: ${searchParams.guests}`}
                        </p>
                    </div>
                </div>
            )}

            {/* Accommodation Grid */}
            <div className="space">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-8 col-lg-7">
                            <div className="row gy-24 gx-24">
                                {loading ? (
                                    <div className="col-12 text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading accommodations...</span>
                                        </div>
                                    </div>
                                ) : accommodations.length > 0 ? (
                                    accommodations.map((accommodation) => (
                                        <div key={accommodation.id} className="col-md-6 col-xl-4">
                                            <div className="tour-box th-ani gsap-cursor">
                                                <div className="tour-box_img global-img">
                                                    <img src={accommodation.main_image || '/assets/img/tour/tour_4_1.jpg'} alt={accommodation.name} />
                                                </div>
                                                <div className="tour-content">
                                                    <h3 className="box-title">
                                                        <a href={`/accommodation/${accommodation.slug}`}>{accommodation.name}</a>
                                                    </h3>
                                                    <div className="tour-rating">
                                                        <div className="star-rating" role="img" aria-label={`Rated ${accommodation.rating} out of 5`}>
                                                            {[...Array(5)].map((_, i) => (
                                                                <span key={i} className={`star ${i < Math.floor(accommodation.rating) ? 'filled' : ''}`}>★</span>
                                                            ))}
                                                        </div>
                                                        <a href={`/accommodation/${accommodation.slug}`} className="woocommerce-review-link">
                                                            ({accommodation.review_count} Reviews)
                                                        </a>
                                                    </div>
                                                    <h4 className="tour-box_price">
                                                        <span className="currency">${accommodation.price_per_night}</span>/Night
                                                    </h4>
                                                    <div className="tour-action">
                                                        <span><i className="fa-light fa-bed"></i>{accommodation.bedrooms} Bedrooms</span>
                                                        <span><i className="fa-light fa-users"></i>Max {accommodation.max_guests} Guests</span>
                                                    </div>
                                                    <a href={`/accommodation/${accommodation.slug}`} className="th-btn style4 th-icon">Book Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center py-5">
                                        <h4>No accommodations found</h4>
                                        <p>Try adjusting your search criteria or check back later.</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Sidebar */}
                        <div className="col-xxl-4 col-lg-5">
                            <aside className="sidebar-area">
                                <div className="widget widget_search">
                                    <h3 className="widget_title">Search Accommodations</h3>
                                    <p>Find the perfect place to stay</p>
                                </div>
                                
                                <div className="widget">
                                    <h3 className="widget_title">Search Parameters</h3>
                                    <ul className="sidebar-list">
                                        {searchParams.location && <li><i className="fa-light fa-location"></i> {searchParams.location}</li>}
                                        {searchParams.type && <li><i className="fa-light fa-home"></i> {searchParams.type}</li>}
                                        {searchParams.checkin && <li><i className="fa-light fa-calendar"></i> {searchParams.checkin} to {searchParams.checkout}</li>}
                                        {searchParams.guests && <li><i className="fa-light fa-users"></i> {searchParams.guests} guests</li>}
                                    </ul>
                                </div>
                            </aside>
                        </div>
                    </div>
                </div>
            </div>

            <FooterThree />
            <ScrollToTop />
        </div>
    );
}

export default Accommodation;
